import { memo, useCallback, useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { BzButton } from '../../components';
import { useDispatch, useSelector } from 'react-redux';
import { GLOBAL_FUNCTION_TYPES, MULTILEG_DATA_OPTION_INDEX, OPTION_CHAIN, ORDER_TYPES, SCRIP_INSTRUMENTS, WATCHLIST_GRID_INDEX } from '../../utils/global_variables';
import { clearOptionChain, toggleOptionChainCheckBox, updateLegDataForOptionChain, updateObjMultiLegData } from '../../redux/actions/optionChain';
import { _createStrategy } from '../../controllers';
import { convertScripResponseWatchlistGrid, getApiExchangeNameFromMktSegId, globalFunctionsEventDispatcher } from '../../utils/global_functions';
import { getScripbyTokenAndMktSegId } from '../../apis';
import { getMultiLegData, updateMultiScripaddLEgModalTabKeyAction } from '../../redux/actions/orders';
import { handleModal, handleModalData } from '../../redux/actions/modals';
import { sendTouchlineRequest } from '../../apis/web_socket';
import { _getExpiryForScrip } from '../../controllers/orders';



const OptionChainToaster = ({ optionChainRef, sideOverview }) => {

    const dispatch = useDispatch();

    const arrLegDataForOptionChain = useSelector(state => state?.optionChain?.arrLegDataForOptionChain);
    const objOptionChainPayload = useSelector(state => state?.optionChain?.objOptionChainPayload);
    const whatsHotData = useSelector(state => state.dontMiss.whatsHotData);
    const isSideOptionChainSticked = useSelector(state => state?.optionChain?.isSideOptionChainSticked);
    const objMultiLegData = useSelector(state => state?.optionChain?.objMultiLegData);
    const multiLegData = useSelector(state => state.orders?.multiLegData);
    const objScripsRequested = useSelector(state => state?.optionChain?.objScripsRequested);
    const arrFutureTabData = useSelector(state => state.marketOverview?.arrFutureTabData);
    const [selectedLegs, setSelectedLegs] = useState([]);

    useEffect(() => {
        if (arrLegDataForOptionChain?.length > 0) {
            let sortedArr = arrLegDataForOptionChain?.sort((a, b) => a[MULTILEG_DATA_OPTION_INDEX.LEG_NUMBER] - b[MULTILEG_DATA_OPTION_INDEX.LEG_NUMBER]);
            setSelectedLegs(sortedArr);
        } else { }

    }, [arrLegDataForOptionChain]);

    const getType = (optiontype) => {
        return (optiontype === 'NA' || optiontype === '') ? SCRIP_INSTRUMENTS.FUT : optiontype;
    };

    const isDataSame = useCallback((multiLegData, arrLegDataForOptionChain) => {
        const unmatched = [];
        const matched = [];

        arrLegDataForOptionChain?.forEach((eachLeg) => {
            const legKey = eachLeg[MULTILEG_DATA_OPTION_INDEX.SEGMENT_ID] + '_' +
                eachLeg[MULTILEG_DATA_OPTION_INDEX.TOKEN] + '_' +
                eachLeg[MULTILEG_DATA_OPTION_INDEX.SCRIP_TYPE];

            let extra = [];
            const isMatch = multiLegData?.some((eachMultiLeg) => {
                extra = eachMultiLeg;
                const multiLegKey = eachMultiLeg?.extraInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] + '_' +
                    eachMultiLeg?.extraInfo[WATCHLIST_GRID_INDEX.TOKEN] + '_' +
                    getType(eachMultiLeg?.optiontype);
                return legKey === multiLegKey;
            });

            if (isMatch) {
                matched.push(extra);
            } else {
                unmatched.push(eachLeg);
            }
        });

        return [
            unmatched.length > 0,
            unmatched,
            matched
        ];
    }, []);


    /*
        Below function gets called when user clicks on Add Sleected legs or Create Strategy
        Converts selected legs in legs data structure used for mUltileg
    */
    const onClickAddSelectedLegsButton = useCallback(async () => {
        if (isSideOptionChainSticked) {
            globalFunctionsEventDispatcher([GLOBAL_FUNCTION_TYPES.CLOSING_SIDETRAY]);
        }
        // unsubscribe visible rows here
        if (Object?.keys(objScripsRequested)?.length > 0) {
            let arrDataToUnsubScribe = Object?.keys(objScripsRequested)?.map((eachToken) => {
                return { exchangeId: Number(eachToken?.split("_")[0]), token: Number(eachToken?.split("_")[1]), isSubscribe: false };
            });
            sendTouchlineRequest(arrDataToUnsubScribe);
        } else { }
        dispatch(handleModal([{ 'OPTION_CHAIN': false }]));
        dispatch(updateLegDataForOptionChain());
        let expiryListArrayForMultiLeg = [];
        if (objOptionChainPayload?.location === OPTION_CHAIN.MULTI_LEG) {
            dispatch(updateMultiScripaddLEgModalTabKeyAction("futures"));
            if (!isDataSame(multiLegData, arrLegDataForOptionChain)[0]) {
                dispatch(clearOptionChain());
                dispatch(handleModal([{ 'OPTION_CHAIN': false }, { "ADD_LEG_MODAL": false }]));
                dispatch(updateObjMultiLegData({}));
                return;
            }
            let filteredData = isDataSame(multiLegData, arrLegDataForOptionChain)[1];
            let nonFiltereddata = isDataSame(multiLegData, arrLegDataForOptionChain)[2];
            multiLegData?.forEach((eachLeg) => {
                // Code block to add expiry array from base scrip to option contract selected by user in normal multi leg flow
                if (expiryListArrayForMultiLeg?.length === 0) {
                    expiryListArrayForMultiLeg = eachLeg.expiryList;
                }
            });
            if (filteredData?.length > 0) {
                let arrTokenData = filteredData?.map((eachKey) => {
                    return { mkt: getApiExchangeNameFromMktSegId(eachKey[MULTILEG_DATA_OPTION_INDEX.SEGMENT_ID]), token: Number(eachKey[MULTILEG_DATA_OPTION_INDEX.TOKEN]) };
                });
                let newInfo = await getScripbyTokenAndMktSegId(arrTokenData);
                let obj = {};
                await convertScripResponseWatchlistGrid(newInfo?.data?.result)?.forEach((eachScrip) => {
                    obj[eachScrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]] = eachScrip;
                });
                const objResp = _createStrategy(filteredData, objOptionChainPayload, obj, filteredData?.length === 3 ? [] : nonFiltereddata, expiryListArrayForMultiLeg);
                if (objResp?.data?.length > 0) {
                    dispatch(getMultiLegData([...objResp?.data]));
                    dispatch(handleModal([{ "ADD_LEG_MODAL": false }]));
                    // update multileg data here
                    // close what ever modal open and then open orderEntry model
                    dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': false }]));
                    // dispatch(handleModalData({ data: { orderEntryTab: ORDER_TYPES.MULTI_SCRIP, activeTabKey: ORDER_TYPES.MULTI_LEG } }));
                    dispatch(clearOptionChain());
                    dispatch(updateObjMultiLegData({}));
                }
            }

            dispatch(handleModal([{ "ADD_LEG_MODAL": false }]));
            dispatch(clearOptionChain());
            dispatch(updateObjMultiLegData({}));
            // legs need to be added to existing legs only one leg here
        } else {
            let arrTokenData = arrLegDataForOptionChain?.map((eachKey) => {
                return { mkt: getApiExchangeNameFromMktSegId(eachKey[MULTILEG_DATA_OPTION_INDEX.SEGMENT_ID]), token: Number(eachKey[MULTILEG_DATA_OPTION_INDEX.TOKEN]) };
            });
            let newInfo = await getScripbyTokenAndMktSegId(arrTokenData);
            let obj = {};
            let arrScripInfo = [];
            await convertScripResponseWatchlistGrid(newInfo?.data?.result)?.forEach((eachScrip) => {
                obj[eachScrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]] = eachScrip;
                if (arrScripInfo?.length === 0) {
                    arrScripInfo = eachScrip;
                }
            });
            // Last argument is expiry list array from redux as user is doing this flow from option chain inside overview
            const objResp = _createStrategy(arrLegDataForOptionChain, objOptionChainPayload, obj, [], []);
            if (objResp?.data?.length > 0) {
                dispatch(getMultiLegData([...objResp?.data]));
                // update multileg data here
                // close what ever modal open and then open orderEntry model
                dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': false }, { 'ORDER_ENTRY_MODAL': true }]));
                dispatch(handleModalData({ data: { orderEntryTab: ORDER_TYPES.MULTI_SCRIP, activeTabKey: ORDER_TYPES.MULTI_LEG } }));
                dispatch(clearOptionChain());
                dispatch(updateObjMultiLegData({}));
            }
        }
        dispatch(updateLegDataForOptionChain());
        //close modal and clear objumultileg data of option chain




    }, [objOptionChainPayload, isSideOptionChainSticked, arrLegDataForOptionChain, multiLegData, objScripsRequested,   isDataSame, dispatch]);

    /*
        Below function gets called when user clicks on Close button of the chip of selected leg with strike price and data and type
    */
    const handleRemoveLegFromToaster = useCallback((event, leg, index) => {
        setSelectedLegs(prevState => {
            let updated = [...prevState];
            updated.splice(index, 1);
            updated = updated.map((item, idx) => {
                const newItem = [...item]; // Copy sub-array
                newItem[0] = idx + 1; // Set new sequence number
                return newItem;
            });
            dispatch(updateLegDataForOptionChain(updated));
            return updated;
        });
    }, [optionChainRef, objMultiLegData, dispatch]);

    /*
        Below Function gets called when user click on cancell all buton and revers the grid with its orginal state
    */
    const handleCancelAllLegs = useCallback(() => {
        dispatch(updateLegDataForOptionChain([]));
        setTimeout(() => {
            dispatch(toggleOptionChainCheckBox(false));
        }, 200);
        setSelectedLegs([]);
    }, [dispatch]);

    const getDateAndShortMonth = useCallback((expiryDate) => {
        const day = new Date(expiryDate).getDate();
        const shortMonth = new Date(expiryDate).toLocaleString("default", { month: "short" });
        return `${day} ${shortMonth}`;
    }, []);
    return (
        <Container fluid className={`toastmessage-card w-95 ${sideOverview ? 'w-40' : ''}`}>
            <Row className='g-0'>
                <Col md={8} className='d-flex justify-content-start align-items-center'>
                    <div className='font-regular font-size2 toastmessage-textcolor me-2'>Legs</div>
                    <div className='horizontal-scroll-wrap'>
                        <span>{<div className='toast-filters-chips-wrap pb-1'>
                            {
                                selectedLegs?.length > 0 && selectedLegs?.map((row, index) => {
                                    return (<div key={index} className='filter-chip me-2'>
                                        <div className='p-t-2 text-capitalize'>{`${getDateAndShortMonth(row[MULTILEG_DATA_OPTION_INDEX?.NEXPIRY_DATE])} ${row[MULTILEG_DATA_OPTION_INDEX?.SCRIP_TYPE] !== 'FUT' ? row[MULTILEG_DATA_OPTION_INDEX.STRIKE_PRICE] : ''} ${row[MULTILEG_DATA_OPTION_INDEX?.SCRIP_TYPE]}`}</div>
                                        <div className='icon-12 icon-close icon-light ms-2'
                                            onClick={(e) => handleRemoveLegFromToaster(e, row, index)}
                                        ></div>
                                    </div>);
                                }
                                )
                            }
                        </div>}</span>
                    </div>
                </Col>
                <Col md={4} className='d-flex justify-content-end align-items-center text-end'>
                    {objOptionChainPayload?.location !== OPTION_CHAIN.MULTI_LEG && <BzButton type="button" className='btn btn-sm btn-light ms-2' onClick={handleCancelAllLegs} >
                        Cancel All
                    </BzButton>}
                    {
                        <BzButton type="button" className='btn btn-sm btn-light ms-2' onClick={onClickAddSelectedLegsButton}
                            disabled={selectedLegs?.length > 1 ? false : true}>
                            {objOptionChainPayload?.location === OPTION_CHAIN.MULTI_LEG ? 'ADD SELECTED LEGS' : 'Create Strategy'}
                        </BzButton>
                    }
                </Col>
            </Row>
        </Container>
    );
};


export default memo(OptionChainToaster);


